import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { getMasterData } from '../../AddComplain/api';
import { addSchoolImage, getSchoolUploadHistory } from './api';
import PhotoUploadScreen from '../../../components/officerShell/PhotoUploadScreen';

const clean = (v) => String(v || '').trim();

const SchoolReport = (props) => {
    const { blockName, districtName } = props.auth.auth;
    // One request loads the district's (or a BEO's block's) schools; the block
    // list and each block's school list are both derived from it.
    const schoolsRef = useRef(null);

    const loadSchools = () => {
        if (!schoolsRef.current) {
            const query = blockName
                ? `blockName=${encodeURIComponent(blockName)}`
                : `districtName=${encodeURIComponent(districtName || '')}`;
            schoolsRef.current = getMasterData(`?type=SCHOOL&${query}`).then((d) => d || []);
        }
        return schoolsRef.current;
    };

    return (
        <PhotoUploadScreen
            eyebrow="School Inspection"
            title="Add School Document"
            subtitle="कृपया निरिक्षण की फोटो अपलोड करें"
            item={{ label: 'School', labelHi: 'विद्यालय', noun: 'school', plural: 'schools' }}
            fixedBlock={blockName || ''}
            loadBlocks={async () =>
                [...new Set((await loadSchools()).map((s) => clean(s.blockName)).filter(Boolean))].sort()
            }
            loadItems={async (block) =>
                (await loadSchools())
                    .filter((s) => clean(s.blockName) === block)
                    .map((s) => ({ value: s.schoolUdiseCode, label: `${s.schoolName} (${s.schoolUdiseCode})` }))
            }
            upload={({ item, file, date }) => {
                const fd = new FormData();
                fd.append('udiseCode', item.value);
                fd.append('school', file);
                fd.append('createdAt', date);
                return addSchoolImage(fd);
            }}
            fetchHistory={getSchoolUploadHistory}
        />
    );
};

const mapStateToProps = (state) => ({ auth: state.Auth });

export default connect(mapStateToProps)(SchoolReport);
